module.exports = __webpack_public_path__ + "static/media/favicon03.d959e6d4.webp";